var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.994h2.333a2 2 0 0 0 1.2-.4l2.416-1.812a1.515 1.515 0 0 1 1.98 2.284l-2.073 2.073a4 4 0 0 1-2.044 1.094l-2.93.585c-.581.117-1.18.102-1.755-.042l-2.65-.662a3.962 3.962 0 0 0-.97-.12H7m6.002-3h1.485c.836 0 1.515-.678 1.515-1.515v-.3c0-.695-.473-1.3-1.147-1.469l-2.292-.573a4.69 4.69 0 0 0-3.744.646l-1.817 1.211H3.003v4.997h3.999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.805 16.654 17 7H7l-.75 9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9V5a2 2 0 1 1 4 0v4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgProducts;